import type { SdkWidgetSettings } from '../types';
import { el, on } from './dom-utils';
// @ts-expect-error Vite ?raw import
import logoSvg from '../assets/logo-short-dark-mode.svg?raw';

const FAB_LOGO_DATA_URL =
  'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(logoSvg as string);

export interface FloatingActionButtonCallbacks {
  onClick: () => Promise<void>;
}

/**
 * Renders the floating Veridion action button (circular, with logo image).
 * Position is controlled by settings.fabPosition (top-left, top-right, bottom-left, bottom-right).
 */
export function createFloatingActionButton(
  settings: SdkWidgetSettings,
  callbacks: FloatingActionButtonCallbacks,
): HTMLElement {
  const fabPosition = (settings.fabPosition || 'bottom-right').toLowerCase();
  const positionClass =
    ['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(fabPosition)
      ? `vrd-fab-wrap--${fabPosition}`
      : 'vrd-fab-wrap--bottom-right';
  const wrap = el('div', { className: `vrd-fab-wrap ${positionClass}` });

  const btn = el('button', {
    type: 'button',
    className: 'vrd-fab',
    'aria-label': 'Cookie settings – Veridion. Powered by Oziriz31',
    title: 'Cookie settings – Veridion. Powered by Oziriz31',
  }) as HTMLButtonElement;
  const img = el('img', {
    src: FAB_LOGO_DATA_URL,
    alt: '',
    className: 'vrd-fab__img',
  }) as HTMLImageElement;
  const spinner = el('span', { className: 'vrd-fab__spinner', 'aria-hidden': 'true' });
  btn.appendChild(img);
  btn.appendChild(spinner);
  wrap.appendChild(btn);

  on(btn, 'click', async () => {
    btn.disabled = true;
    btn.classList.add('vrd-fab--loading');
    try {
      await callbacks.onClick();
    } finally {
      btn.disabled = false;
      btn.classList.remove('vrd-fab--loading');
    }
  });

  return wrap;
}
